<template>
  <router-view/>
</template>
<style lang="scss">
body{
  background: #f7f7f7;
}
</style>
